(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kies-whp-simple"]) return;
  try {
    
(() => {
  function start(host) {
    if (host.dataset.ready) return;
    const root = host.querySelector('.kies-build');
    const config = JSON.parse(host.querySelector('.kb-cart-config').textContent);
    const ui = JSON.parse(host.querySelector('[data-ks-text]').textContent);
    const decoder = document.createElement('textarea');
    for (const key of Object.keys(ui)) { decoder.innerHTML=ui[key]; ui[key]=decoder.value; }
    const engine=config.engine.toLowerCase();
    const boxes = [...root.querySelectorAll('[data-kb-tier]')];
    if (!boxes.length) return;
    host.dataset.ready = 'true';
    const make = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; };
    const disclosure = (title) => { const d = make('details','ks-details'); d.append(make('summary','',title)); const b=make('div','ks-detail-body'); d.append(b); return [d,b]; };
    const controls = host.querySelector('[data-ks-controls]');
    const family = controls.querySelector('[data-ks-family]');
    const goals = controls.querySelector('[data-ks-goals]');
    const prompt = controls.querySelector('[data-ks-prompt]');
    const workspace = make('div','ks-workspace');
    const research = make('div','ks-research');
    research.append(make('h2','',ui.research));
    const tiers = new Map();
    for (const box of boxes) {
      const section = box.closest('section');
      tiers.set(box.dataset.kbTier,section);
      const [details,body] = disclosure(ui.technical);
      for (const child of [...section.children]) {
        if (child===box || child.matches('.kb-quarter-mile, .kqm, [data-quarter-mile]') || child.querySelector('.kqm-range') || child.matches('h3,.kb-tier-head')) continue;
        if (child.className && /quarter|kqm/.test(child.className)) continue;
        body.append(child);
      }
      const qm=section.querySelector('.kb-quarter-mile');
      if(qm){const [qd,qb]=disclosure(ui.assumptions);qb.append(qm);section.append(qd);}
      section.append(details);
      section.classList.add('ks-tier'); section.hidden=true;
      workspace.append(section);
      const left = make('div','ks-configuration');
      const right = make('aside','ks-package');
      right.append(make('p','ks-kicker',ui.package),make('h3','ks-summary-title',Number(config.tiers[box.dataset.kbTier].target || box.dataset.kbTier.replace('g1-','')).toLocaleString()+' WHP'));
      const summary = make('p','ks-summary-total',ui.chooseSetup); right.append(summary);
      const mini = make('div','ks-summary-items'); right.append(mini);
      right.append(make('p','ks-summary-note',ui.totalNote));
      const actions=box.querySelector('.kb-cart-actions'); const status=box.querySelector('[data-kb-status]');
      for (const child of [...box.children]) if(child!==actions && child!==status) left.append(child);
      right.append(actions,status);box.append(left,right);
      left.querySelector('h3').textContent=ui.setup;
      const review=left.querySelector('[data-kb-review]');
      const groupFor = (row) => {
        const text=row.querySelector('.kb-cart-check span')?.textContent || '';
        if(/cool|radiator|heat exchanger|intercooler/i.test(text))return ui.cooling;
        if(/transmission|8hp|driveshaft|axle|xhp|clutch/i.test(text))return ui.drivetrain;
        if(/fuel|injector|dorch|ethanol|flex|rev2|reflex|mot iv|motive|pi harness|pressure sensor/i.test(text))return ui.fueling;
        if(/cool|radiator|heat exchanger|intercooler/i.test(text))return ui.cooling;
        if(/engine|piston|rod |stud|gasket|plug|catch can|camshaft/i.test(text))return ui.engine;
        return ui.turbo;
      };
      let queued=false;
      const refresh = () => {
        queued=false;
        const items=review.querySelector('.kb-cart-items');
        if(items && !items.dataset.grouped) {
          items.dataset.grouped='true';
          const grouped=new Map();
          for(const row of [...items.querySelectorAll('[data-kb-row]')]) {const key=groupFor(row);if(!grouped.has(key))grouped.set(key,[]);grouped.get(key).push(row);}
          for(const [label,rows] of grouped) {items.append(make('h4','ks-part-group',label));for(const row of rows)items.append(row);}
        }
        summary.textContent=review.hidden ? ui.chooseSetup : review.querySelector('[data-kb-total]')?.textContent || ui.chooseSetup;
        mini.replaceChildren();
        if(!review.hidden) {
          for(const row of review.querySelectorAll('[data-kb-row]'))if(row.querySelector('[data-kb-include]')?.checked)mini.append(make('p','',row.querySelector('.kb-cart-check span').textContent));
        }
        const active = tiers.get(box.dataset.kbTier);
        if(active && !active.hidden)host.querySelector('[data-ks-mobile-total]').textContent=summary.textContent;
      };
      new MutationObserver(()=>{if(!queued){queued=true;queueMicrotask(refresh);}}).observe(review,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['hidden']});
      box.addEventListener('change',()=>queueMicrotask(refresh));
      box._ksRefresh=refresh;
      refresh();
    }
    const hero=root.querySelector('.kb-hero');
    const [intro,introBody]=disclosure(ui.background);
    for(const child of [...root.children]) {
      if(child===hero || child.tagName==='STYLE')continue;
      if(child.matches('nav,.kb-meta,.kb-intro')) {introBody.append(child);continue;}
      if(child.tagName==='SECTION') {
        const heading=child.querySelector('h2,h3');
        const [d,b]=disclosure(heading?.textContent || ui.technical); b.append(child); research.append(d);
      } else if(child.id==='build-disclaimer') {
        const [d,b]=disclosure(ui.disclaimer);b.append(child);research.prepend(d);
      } else introBody.append(child);
    }
    research.append(intro);
    root.append(controls,workspace,research);
    controls.hidden=false;
    host.classList.add('ks-ready');
    const families=engine==='b58' ? [['gen2',ui.gen2],['gen1',ui.gen1]] : engine==='supra' ? [['p2',ui.p2],['p6',ui.p6]] : [['g8x',ui.g8x],['f97f98',ui.f97f98]];
    for(const [value,label] of families)family.add(new Option(label,value));
    let selected='';
    const cardButtons=[];
    function keyFor(power){return (family.value==='gen1'?'g1-':engine==='supra'?family.value+'-':family.value==='f97f98'?'suv-':'')+power;}
    function renderFitment(){controls.querySelector('.ks-fitment').textContent=ui['fitment_'+family.value] || (engine==='supra'?ui.fitment_supra:ui.fitment);}
    for(const power of [500,800,1000,1200]) {
      const button=make('button','ks-goal');button.type='button';button.dataset.power=power;button.setAttribute('aria-pressed','false');
      button.append(make('strong','',power.toLocaleString()),make('span','',ui.whp),make('small','ks-estimate',ui.chooseVehicle));
      button.disabled=true;goals.append(button);cardButtons.push(button);
      button.addEventListener('click',()=>activate(keyFor(power),true));
    }
    function renderCards() {
      renderFitment();
      for(const button of cardButtons){
        button.disabled=!family.value;
        const f=family.value==='g8x'?'s58':family.value;
        const range=ui['range_'+f+'_'+button.dataset.power];
        button.querySelector('.ks-estimate').textContent=!family.value?ui.chooseVehicle:range?range+' · '+ui.quarter:family.value==='f97f98'?ui.suvTarget:ui.supraTarget;
      }
    }
    function activate(key,writeHash) {
      selected=key;
      for(const [k,tier] of tiers)tier.hidden=k!==key;
      for(const b of cardButtons)b.setAttribute('aria-pressed',String(b.dataset.power===key.replace(/^(g1-|p2-|p6-|suv-)/,'')));
      prompt.hidden=!!key;
      host.querySelector('[data-ks-mobile]').hidden=!tiers.has(key);
      const box=boxes.find(b=>b.dataset.kbTier===key);box?._ksRefresh();
      if(writeHash)history.replaceState(null,'','#'+tiers.get(key).id);
    }
    renderFitment();
    family.addEventListener('change',()=>{renderCards();activate('',false);history.replaceState(null,'',location.pathname+location.search);});
    function revealHash() {
      const id=decodeURIComponent(location.hash.slice(1));if(!id)return;
      const target=document.getElementById(id);if(!target || !host.contains(target))return;
      const tier=target.closest('.ks-tier');
      if(tier){const entry=[...tiers].find(([,v])=>v===tier);family.value=entry[0].startsWith('g1-')?'gen1':engine==='b58'?'gen2':engine==='supra'?entry[0].split('-')[0]:entry[0].startsWith('suv-')?'f97f98':'g8x';renderCards();activate(entry[0],false);}
      let parent=target.parentElement;while(parent && parent!==host){if(parent.tagName==='DETAILS')parent.open=true;parent=parent.parentElement;}
      if(target.tagName==='DETAILS')target.open=true;
      target.scrollIntoView({block:'start'});
    }
    host.addEventListener('click',event=>{const link=event.target.closest('a[href^="#"]');if(link){setTimeout(revealHash,0);}});
    window.addEventListener('hashchange',revealHash);
    host.querySelector('[data-ks-mobile]').addEventListener('click',()=>{const box=boxes.find(b=>b.dataset.kbTier===selected);box?.querySelector('.ks-package').scrollIntoView({behavior:'smooth',block:'start'});});
    revealHash();
    for(const link of root.querySelectorAll('a[href*="view=kies-build-"]')) {
      const url=new URL(link.href,location.href);
      if(['kies-build-b58','kies-build-s58','kies-build-supra'].includes(url.searchParams.get('view'))){url.searchParams.delete('preview_theme_id');link.href=url.href;}
    }
  }
  const init=()=>document.querySelectorAll('[data-ks-simple]').forEach(start);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const desktopQuery = window.matchMedia('(min-width: 750px)');

    function syncDrawerTargetsByViewport() {
      const drawerToggles = document.querySelectorAll(
        '.toggle-title[data-view-content="sidebar"], .toggle-title[data-view-content="popup"]'
      );

      drawerToggles.forEach((toggleTitle) => {
        const currentTarget = toggleTitle.getAttribute('data-side-drawer');
        if (currentTarget) {
          toggleTitle.dataset.sideDrawerDesktop = currentTarget;
        }

        if (desktopQuery.matches) {
          if (toggleTitle.dataset.sideDrawerDesktop) {
            toggleTitle.setAttribute('data-side-drawer', toggleTitle.dataset.sideDrawerDesktop);
          }
        } else {
          toggleTitle.removeAttribute('data-side-drawer');
        }
      });
    }

    function initShowMore(scope = document) {
      const showMoreButtons = scope.querySelectorAll('[data-show-more-button]');

      showMoreButtons.forEach((button) => {
        const toggleContent = button.closest('.toggle-content');
        const content = toggleContent ? toggleContent.querySelector('[data-show-more-content]') : null;

        if (!toggleContent || !content || button.__showMoreInitialized) return;

        const readMoreLabel = button.dataset.readMoreLabel || 'Read More';
        const readLessLabel = button.dataset.readLessLabel || 'Read Less';

        const getMaxHeight = () => {
          const maxHeight = parseInt(getComputedStyle(content).getPropertyValue('--max-content-height'), 10);
          return Number.isNaN(maxHeight) ? 0 : maxHeight;
        };

        const setCollapsedState = () => {
          content.classList.remove('is-expanded');
          button.textContent = readMoreLabel;
          button.setAttribute('aria-expanded', 'false');
        };

        const refreshVisibility = () => {
          const isDesktop = desktopQuery.matches;

          if (!isDesktop) {
            content.classList.add('is-expanded');
            button.hidden = true;
            button.textContent = readMoreLabel;
            button.setAttribute('aria-expanded', 'false');
            return;
          }

          setCollapsedState();

          const shouldShowButton = getMaxHeight() > 0 && content.scrollHeight > getMaxHeight() + 1;
          button.hidden = !shouldShowButton;

          if (!shouldShowButton) {
            content.classList.add('is-expanded');
          }
        };

        button.addEventListener('click', function () {
          const isExpanded = content.classList.toggle('is-expanded');
          button.textContent = isExpanded ? readLessLabel : readMoreLabel;
          button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        });

        window.addEventListener('resize', refreshVisibility);
        refreshVisibility();
        button.__showMoreInitialized = true;
      });
    }

    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach((t) => t.classList.remove('is-active'));
          tabContents.forEach((c) => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach((toggleLink) => {
      toggleLink.addEventListener('click', function (e) {
        e.preventDefault();

        const isDesktop = window.matchMedia('(min-width: 750px)').matches;

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        if (!isDesktop) {
          e.stopPropagation();
          toggleTitle.classList.toggle('is-open');
          return;
        }

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('.drawer-content-wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              initShowMore(drawerContent);
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              initShowMore(popupContent);
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');

      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach((videoOpenPopup) => {
          videoOpenPopup.addEventListener('click', function (e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
    initShowMore();
    syncDrawerTargetsByViewport();
    window.addEventListener('resize', syncDrawerTargetsByViewport);
  });

  } catch(e) { console.error(e); }
})();
})();
